import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { ValidationErrors } from '../../lib/models/validation/validation-errors';

@Component({
  selector: 'boi-generic-date-input',
  templateUrl: './generic-date-input.component.html',
  styleUrls: ['./generic-date-input.component.scss']
})
export class GenericDateInputComponent {
  constructor(protected cdRef: ChangeDetectorRef) {}

  public hasErrors: boolean;

  @Input() public controlId: any;
  @Input() public labelName: string;
  @Input() public showTooltip = true;
  @Input() public tooltipName: string;
  @Input() public isFieldDisabled: boolean;
  @Input() public validationPropertyNames: Array<string>;
  @Input() public validationErrors: ValidationErrors;
  @Input() public required: boolean;
  @Input() public placeholder = '';
  @Input() public cssClasses = 'label-left label-weight-bold label-font-size-13';

  @Input() public value: any;
  @Output() public readonly valueChange = new EventEmitter<any>();

  public onErrorChange(errorState: boolean): void {
    this.hasErrors = errorState;
    this.cdRef.detectChanges();
  }
}
